<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl">
      <icon name="map" class="w-7 mr-3 fill-gray-700" /> Mapa de Calor
    </h1>

    <section id="form" class="bg-white rounded-md shadow overflow-hidden" :style="{height: (canChangeOrg ? 700 : 550) + 'px'}">
      <form @submit.prevent="track">
        <div class="p-12 -mr-6 -mb-12 flex flex-wrap">
          <div class="pr-6 pb-3 w-full lg:w-1/2">
            <label class="form-label">Campanhas</label>

            <multiselect
              v-model="form.campaign_id"
              placeholder="Selecione..."
              label="name"
              track-by="name"
              :options="dataCampaigns"
              :multiple="true"
              :disabled="realtime"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="false"
              :preselect-first="false"
            >
              <!-- eslint-disable-next-line vue/no-unused-vars -->
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span
                  v-if="values.length &amp;&amp; !isOpen"
                  class="multiselect__single"
                >
                  {{ values.length }} opções selecionadas
                </span>
              </template>
            </multiselect>
          </div>

          <div class="pr-6 pb-3 w-full lg:w-1/2">
            <label class="form-label">QR Codes</label>

            <multiselect
              v-model="form.qrcode_id"
              placeholder="Selecione..."
              label="name"
              track-by="name"
              :options="dataQrcodes"
              :multiple="true"
              :disabled="realtime"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="false"
              :preselect-first="false"
            >
              <!-- eslint-disable-next-line vue/no-unused-vars -->
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span
                  v-if="values.length &amp;&amp; !isOpen"
                  class="multiselect__single"
                >
                  {{ values.length }} opções selecionadas
                </span>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="p-12 -mr-6 -mb-12 flex flex-wrap" :class="{ 'hidden': !canChangeOrg }">
          <div class="pr-6 pb-8 w-full">
            <label class="form-label">Organização:</label>

            <select
              v-model="form.organization"
              class="form-select"
              :disabled="realtime"
              @change="setOrganization"
            >
              <option :value="null" />
              <option v-for="organization in organizations" :key="organization.id" :value="organization.id">
                {{ organization.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="p-12 -mr-6 -mb-12 flex flex-wrap">
          <div class="pr-6 pb-8 w-full lg:w-1/4">
            <label>Data Inicial</label>

            <br /> <br />

            <datepicker
              v-model="form.start_date"
              placeholder="Selecione..."
              :language="ptBR"
              :format="ptBRDateFormatter"
              :disabled="realtime"
              :error="form.errors.start_date"
            />
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/4">
            <label>Data Final</label>

            <br /> <br />

            <datepicker
              v-model="form.end_date"
              placeholder="Selecione..."
              :language="ptBR"
              :format="ptBRDateFormatter"
              :disabled="realtime"
              :error="form.errors.end_date"
            />
          </div>

          <div class="pr-6 pb-8 w-full lg:w-1/4">
            <label class="form-label">Estado</label>

            <select v-model="form.state" class="form-select" :disabled="realtime" @change="setCities">
              <option :value="null" />
              <option v-for="state in states" :key="state.id" :value="state.id">
                {{ state.name }}
              </option>
            </select>
          </div>

          <!-- <div class="pr-6 pb-8 w-full lg:w-1/4">
            <label class="form-label">Município:</label>

            <select v-model="form.city" class="form-select" :disabled="realtime">
              <option :value="null" />
              <option v-for="city in dataCities" :key="city.id" :value="city.id">
                {{ city.name }}
              </option>
            </select>
          </div> -->

          <div class="pr-6 pb-3 w-full lg:w-1/4">
            <label class="form-label">Município</label>

            <multiselect
              v-model="form.city"
              placeholder="Selecione..."
              label="name"
              track-by="name"
              :options="dataCities"
              :multiple="true"
              :disabled="realtime"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="false"
              :preselect-first="false"
            >
              <!-- eslint-disable-next-line vue/no-unused-vars -->
              <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span
                  v-if="values.length &amp;&amp; !isOpen"
                  class="multiselect__single"
                >
                  {{ values.length }} opções selecionadas
                </span>
              </template>
            </multiselect>
          </div>

          <div class="pr-6 pb-8 w-full text-center">
            <button class="btn-indigo" type="submit">
              Consultar
            </button>

            <br /> <br />

            <label class="form-label w-max m-auto">
              <input id="realtime" v-model="realtime" type="checkbox" @change="setRealtime" />
              Em Tempo Real
            </label>
          </div>
        </div>
      </form>
    </section>

    <section id="map" class="p-5 mt-4 bg-white rounded-md shadow overflow-hidden h-75" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Datepicker from 'vuejs-datepicker'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import axios from 'axios'
import { ptBR } from 'vuejs-datepicker/dist/locale'
import { Loader } from '@googlemaps/js-api-loader'

export default {
  metaInfo: {title: 'Mapa de Calor'},
  components: {
    Datepicker,
    Multiselect,
    Icon,
  },
  layout: Layout,
  props: {
    campaigns:     Array,
    qrcodes:       Array,
    organizations: Array,
    states:        Array,
    cities:        Array,
    pins:          Object,
  },
  data() {
    return {
      ptBR: ptBR,
      canChangeOrg: this.$page.props.auth.user.roles.includes('organization-list'),
      dataCities: this.cities,
      dataCampaigns: this.campaigns,
      dataQrcodes: this.qrcodes,
      loader: new Loader({
        apiKey: 'AIzaSyCLiNYDfyaZcWslw7HltDs3KyZGV1ug3AY',
        language: 'pt-BR',
      }),
      g: null,
      map: null,
      mapMarkers: {
        campaigns: {},
        qrcodes: {},
      },
      realtime: false,
      form: this.$inertia.form({
        campaign_id: null,
        qrcode_id: null,
        organization: null,
        start_date: new Date(),
        end_date: new Date(),
        state: null,
        city: null,
      }),
    }
  },
  async mounted() {
    this.g = await this.loader.load()

    this.map = new this.g.maps.Map(
      document.getElementById('map'),
      {
        center            : new this.g.maps.LatLng(-15.797599, -47.891766),
        clickableIcons    : false,
        disableDefaultUI  : false,
        gestureHandling   : 'greedy',
        mapTypeControl    : false,
        streetViewControl : false,
        zoom              : 4,
        zoomControl       : true,
      },
    )
  },
  updated() {
    const unchangedCamnpaigns = () => {
      const keys = Object.keys(this.mapMarkers.campaigns)


      return this.pins?.campaigns.length == keys.length && keys.length != 0
    }

    const unchangedQRcodes = () => {
      const keys = Object.keys(this.mapMarkers.qrcodes)


      return this.pins?.qrcodes.length == keys.length && keys.length != 0
    }

    if((!this.map) || (unchangedCamnpaigns()) || (unchangedQRcodes()))
    {
      return
    }

    this.clearAll()

    if(this.pins)
    {
      this.pins.campaigns.forEach((campaign) => {
        let lat = campaign.latitude
        let lng = campaign.longitude

        if(!lat || !lng)
        {
          const coords = campaign.coordinates.split(',')

          lat = Number(coords[0])
          lng = Number(coords[1])
        }

        const marker = this.createMarker(
          'campaigns',
          campaign.id,
          lat,
          lng,
          campaign.radius,
          campaign.name,
          campaign.start_date,
          campaign.end_date,
          'marker',
        )

        this.mapMarkers.campaigns[campaign.id] = {
          id: campaign.id,
          marker: marker,
          view: {
            infoWindow: null,
            circle: null,
            keep: false,
          },
          interactions: [],
          interactions_ref: [],
          interactions_count: 0,
          campaign: {
            lat: campaign.latitude,
            lng: campaign.longitude,
            radius: campaign.radius,
          },
        }
      })

      this.pins.qrcodes.forEach((qrcode) => {
        const marker = this.createMarker(
          'qrcodes',
          qrcode.id,
          Number(qrcode.latitude),
          Number(qrcode.longitude),
          50,
          qrcode.name,
          qrcode.start_date,
          qrcode.end_date,
          'marker',
        )

        this.mapMarkers.qrcodes[qrcode.id] = {
          id: qrcode.id,
          marker: marker,
          view: {
            infoWindow: null,
            circle: null,
            keep: false,
          },
          interactions: [],
          interactions_ref: [],
          interactions_count: 0,
          qrcode: {
            lat: qrcode.latitude,
            lng: qrcode.longitude,
          },
        }
      })
    }
  },
  methods: {
    createMarker(
      resource,
      id,
      latitude,
      longitude,
      radius,
      name,
      startDate,
      endDate,
      icon,
      newer,
    )
    {
      const position = new this.g.maps.LatLng(latitude, longitude)

      const marker = new this.g.maps.Marker({
        map: this.map,
        position: position,
        icon: createMarkerIcon(icon, resource, this.g, newer),
      })

      if(!startDate && !endDate)
      {
        return marker
      }

      marker.addListener('mouseover', () => {
        if(this.mapMarkers[resource][id].view.keep)
        {
          return
        }

        const startDateFormated = moment(startDate).format('DD/MM/YYYY')
        const endDateFormated = moment(endDate).format('DD/MM/YYYY')

        const infoWindow = new this.g.maps.InfoWindow({
          content: `            
              <div 
                class="text-center" 
                style=" 
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                  justify-content:center;
                  width: 150px; 
                  height: 70px;"
              >
              <span class="font-bold">${name}</span>

              <br />

              <span>${startDateFormated} - ${endDateFormated}</span>
            </div>
          `,
          position: position,
          pixelOffset: new this.g.maps.Size(0, -30),
        })

        infoWindow.open(this.map)

        const circle = new this.g.maps.Circle({
          map: this.map,
          center: position,
          fillColor: (resource == 'campaigns' ? '#770000' : '#000077'),
          fillOpacity: 0.15,
          radius: radius,
          strokeColor: (resource == 'campaigns' ? '#FF0000' : '#0000FF'),
          strokeOpacity: 1,
          strokeWeight: 1,
        })
        this.mapMarkers[resource][id].view.infoWindow = infoWindow
        this.mapMarkers[resource][id].view.circle = circle
      })

      marker.addListener('mouseout', () => {
        if(this.mapMarkers[resource][id].view.keep)
        {
          return
        }

        if(this.mapMarkers[resource][id].view.infoWindow || this.mapMarkers[resource][id].view.circle)
        {
          this.mapMarkers[resource][id].view.infoWindow?.close()

          this.mapMarkers[resource][id].view.circle?.setMap(null)

          this.mapMarkers[resource][id].view.infoWindow = null
          this.mapMarkers[resource][id].view.circle = null
        }
      })

      marker.addListener('click', () => {
        this.mapMarkers[resource][id].view.keep = !this.mapMarkers[resource][id].view.keep

        const hasTrack = (this.mapMarkers[resource][id].interactions.length > 0)

        if(hasTrack)
        {
          this.mapMarkers[resource][id].view.infoWindow?.close()

          this.mapMarkers[resource][id].view.circle?.setMap(null)

          this.clearAllInteractions(resource, id)

          return
        }

        if(this.realtime)
        {
          this.getInteractionsInRealTime(resource, id)

          return
        }

        this.getInteractions(
          resource,
          id,
          this.form.start_date.toISOString().replace('T', ' ').replace('Z', ''),
          this.form.end_date.toISOString().replace('T', ' ').replace('Z', ''),
        ).then(
          (res) => {
            const interactions = res.data

            this.setInteractions(resource, id, interactions)
          },
        )
      })

      return marker

      function createMarkerIcon(icon, resource, g, newer) {
        let color = null
        let path = null
        let scale = null

        switch(icon)
        {
        case 'M':
        case 'F':
        case 'O':
        case null:
          scale = 0.015

          if(icon == 'M')
          {
            color = '#0066CC'
            path = 'M1408 704v416q0 40-28 68t-68 28-68-28-28-68v-352h-64v912q0 46-33 79t-79 33-79-33-33-79v-464h-64v464q0 46-33 79t-79 33-79-33-33-79v-912h-64v352q0 40-28 68t-68 28-68-28-28-68v-416q0-80 56-136t136-56h640q80 0 136 56t56 136zm-288-448q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5z'
          }
          else if(icon == 'F')
          {
            color = '#FF6699'
            path = 'M1536 1056q0 40-28 68t-68 28q-51 0-80-43l-227-341h-45v132l247 411q9 15 9 33 0 26-19 45t-45 19h-192v272q0 46-33 79t-79 33h-160q-46 0-79-33t-33-79v-272h-192q-26 0-45-19t-19-45q0-18 9-33l247-411v-132h-45l-227 341q-29 43-80 43-40 0-68-28t-28-68q0-29 16-53l256-384q73-107 176-107h384q103 0 176 107l256 384q16 24 16 53zm-416-800q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5z'
          }
          else
          {
            // color = '#A6A6A6'
            // path = 'M1088 1256v240q0 16-12 28t-28 12h-240q-16 0-28-12t-12-28v-240q0-16 12-28t28-12h240q16 0 28 12t12 28zm316-600q0 54-15.5 101t-35 76.5-55 59.5-57.5 43.5-61 35.5q-41 23-68.5 65t-27.5 67q0 17-12 32.5t-28 15.5h-240q-15 0-25.5-18.5t-10.5-37.5v-45q0-83 65-156.5t143-108.5q59-27 84-56t25-76q0-42-46.5-74t-107.5-32q-65 0-108 29-35 25-107 115-13 16-31 16-12 0-25-8l-164-125q-13-10-15.5-25t5.5-28q160-266 464-266 80 0 161 31t146 83 106 127.5 41 158.5z'

            color = '#545876'
            path = 'M48 32C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm80 64v64H64V96h64zM48 288c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48zm80 64v64H64V352h64zM256 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zm64 16h64v64H320V96zm32 352v32h32V448H352zm96 0H416v32h32V448zM416 288v32H352V288H256v96 96h64V384h32v32h96V352 320 288H416z'

            scale = 0.05
          }

          if(newer)
          {
            color = '#00F500'

            scale = resource == 'campaigns' && icon ? 0.03 : 0.08
          }

          break

        case 'marker':
          color = (resource == 'campaigns' ? '#F50000' : '#0000F5')
          path = 'M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z'
          scale = 0.07
          break
        }

        return {
          anchor: new g.maps.Point(200, 510),
          fillColor: color,
          fillOpacity: 1,
          labelOrigin: new g.maps.Point(205, 190),
          path: path,
          scale: scale,
          strokeWeight: 0,
        }
      }
    },
    setInteractions(resource, id, interactions) {
      if((!this.realtime && this.mapMarkers[resource][id].interactions.length > 0) || (this.realtime && this.mapMarkers[resource][id].interactions_count > 300))
      {
        this.clearAllInteractions(resource, id)

        return this.setInteractions(resource, id, interactions)
      }

      if(this.mapMarkers[resource][id].interactions_ref.length == 0)
      {
        this.mapMarkers[resource][id].interactions_ref = interactions
      }

      interactions.forEach((interaction) => {
        const exists = interactionMarkerExists(interaction, this.mapMarkers[resource][id].interactions)
        const newer = isInteractionNewer(interaction, this.mapMarkers[resource][id].interactions_ref)

        if(this.realtime && exists)
        {
          return
        }

        const position = makeRandomPosition(this.mapMarkers[resource][id])

        const I = {
          marker: null,
          infoWindow: null,
          id: interaction.interaction_id,
        }

        const interactionMarker = this.createMarker(
          resource,
          id,
          position.lat,
          position.lng,
          1,
          interaction.user_name,
          null,
          null,
          interaction.user_gender,
          newer,
        )

        interactionMarker.addListener('mouseover', () => {
          const cityText = interaction.city_origin ? `ORIGEM DE ${interaction.city_origin}` : ''

          const view = new this.g.maps.InfoWindow({
            content: `
              <div 
                class="text-center" 
                style=" 
                  display: flex;
                  align-items: center;
                  flex-direction: column;
                  justify-content:center;
                  width: 150px; 
                  height: 70px;"
              >
                <span class="font-bold">
                  ${resource == 'qrcodes' ? 'IMPACTO QR CODE' : interaction.user_first_name ?? 'IMPACTO QR CODE'}
                  <br />
                  Impacto em ${interaction.interaction_date}
                </span>

                <br /> <br />

                <span>${cityText}</span>
              </div>
            `,
            position: interactionMarker.getPosition(),
            pixelOffset: new this.g.maps.Size(10, -10),
          })

          view.open(this.map)

          I.infoWindow = view
        })

        interactionMarker.addListener('mouseout', () => {
          I.infoWindow.close()

          I.infoWindow = null
        })

        I.marker = interactionMarker

        this.mapMarkers[resource][id].interactions.push(I)

        function makeRandomPosition(resource) {
          const centerLat = resource?.campaign?.lat ?? resource?.qrcode?.lat
          const centerLng = resource?.campaign?.lng ?? resource?.qrcode?.lng
          const maxRadius = resource?.campaign?.radius ?? 50

          const EARTH = 6371
          const ONE_DEGREE = (EARTH * 2 * Math.PI / 360 * 1000)

          const r = maxRadius * (Math.random() ** 0.5)
          const theta = Math.random() * 2 * Math.PI

          const rLat = (r * Math.sin(theta))
          const rLng = (r * Math.cos(theta))

          return {
            lat: centerLat + (rLat / ONE_DEGREE),
            lng: centerLng + (rLng / (ONE_DEGREE * Math.cos(centerLat * Math.PI / 180))),
          }
        }

        function interactionMarkerExists(interaction, interactions)
        {
          let exists = false

          interactions.forEach((existing) => {
            if(interaction.interaction_id == existing.id)
            {
              exists = true
            }
          })

          return exists
        }

        function isInteractionNewer(interaction, references)
        {
          let newer = true

          references.forEach((ref) => {
            if(interaction.interaction_id == ref.interaction_id)
            {
              newer = false
            }
          })

          return newer
        }
      })

      this.mapMarkers[resource][id].interactions_count++
    },
    setRealtime() {
      Object.keys(this.mapMarkers).forEach((resource) => {
        Object.keys(this.mapMarkers[resource]).forEach((id) => {
          if(this.mapMarkers[resource][id].view.keep)
          {
            this.getInteractionsInRealTime(resource, id)
          }
        })
      })
    },
    getInteractions(resource, id, startDate, endDate) {
      return axios.get(
        this.route(
          `map.${resource}`,
          {
            id: id,
            start_date: startDate,
            end_date: endDate,
          },
        ),
      )
    },
    getInteractionsInRealTime(resource, id) {
      if(!this.realtime)
      {
        return
      }

      const startDate = moment().subtract(1, 'hour').format('YYYY-MM-DD HH:mm:ss')
      const endDate = moment().format('YYYY-MM-DD HH:mm:ss')

      this.getInteractions(resource, id, startDate, endDate).then(
        (res) => {
          const interactions = res.data

          if(this.mapMarkers[resource][id].view.keep)
          {
            this.setInteractions(resource, id, interactions)

            if(this.realtime)
            {
              setTimeout(this.getInteractionsInRealTime, 2e3, resource, id)
            }
          }
        },
      )
    },
    clearAll() {
      Object.keys(this.mapMarkers).forEach((resource) => {
        Object.keys(this.mapMarkers[resource]).forEach((id) => {
          this.mapMarkers[resource][id].marker.setMap(null)

          this.mapMarkers[resource][id].view.infoWindow?.close()
          this.mapMarkers[resource][id].view.circle?.setMap(null)
        })
      })

      this.mapMarkers = {
        campaigns: {},
        qrcodes: {},
      }
    },
    clearAllInteractions(resource, id) {
      this.mapMarkers[resource][id].interactions.forEach((interaction) => {
        interaction.marker.setMap(null)
        interaction.infoWindow?.close()
      })

      this.mapMarkers[resource][id].interactions = []
      this.mapMarkers[resource][id].interactions_ref = []
      this.mapMarkers[resource][id].interactions_count = 0
    },
    track() {
      if(this.realtime)
      {
        return
      }

      if(Object.keys(this.mapMarkers.campaigns).length > 0 || Object.keys(this.mapMarkers.qrcodes).length > 0)
      {
        this.clearAll()
      }

      this.form.post(this.route('map.track'))
    },
    setOrganization() {
      this.dataCampaigns = this.campaigns
      this.dataQrcodes   = this.qrcodes

      if(!this.form.organization)
      {
        return
      }

      this.dataCampaigns = this.dataCampaigns.filter((campaign) => campaign.organization == this.form.organization)
      this.dataQrcodes   = this.dataQrcodes.filter((qrcode) => qrcode.organization == this.form.organization)
    },
    setCities() {
      if(this.dataCities.length > 0 && this.states.length == 1)
      {
        return
      }

      axios.get(
        this.route('cities'),
        {
          params: {
            stateId: this.form.state,
          },
        })
        .then((response) => {
          const cities = response.data

          this.dataCities.splice(0, this.dataCities.length)

          this.dataCities = cities
        })
    },
    ptBRDateFormatter(date) {
      moment.locale('pt-br')

      return moment(date).format('L')
    },
  },
}
</script>

<style>
  #map
  {
    height: 600px;
  }

  #map button.gm-ui-hover-effect
  {
    display: none !important;
  }
</style>
